import React from "react"
import { MainCP } from "../../Components/Ministerio-conocimiento/MainCP"

const ViewMinisterio: React.FC = () => <MainCP/>

export default ViewMinisterio